export type ConfigurationsState = {
	sitePreferences: SitePreferences;
	organizationPreferences: Record<string, unknown>;
	passwordConfig: PasswordConfig;
	countries: Country[];
	languages: Language[];
	currentCountryCode: string;
	currentLanguageCode: string;
	siteChangingStatus: string;
	geolocation: Record<string, unknown>;
	taxationPolicy?: string;
	cms: CMS;
	currencyConversionRates: {
		[key: string]: {
			[key: string]: number;
		};
	};
	customerGroups: unknown[];
};

export type ReceiveCountryCurrencyRatesPayload = {
	from: string;
	to: string;
	rate: number;
};

interface CountryCurrencyAreaConfig {
	standard: string[];
	sale: string[];
}

export interface CountryCurrencyConfig {
	delimiter?: string;
	areas?: {
		[key: string]: CountryCurrencyAreaConfig;
	};
	roundUpPriceFactor?: {
		[key: string]: number;
	};
}

export interface ICountryPriceLocaleSettings {
	decimalSeparator: string;
	thousandSeparator: string;
	currencyFirst: boolean;
}
export interface ICountryLocaleSettings {
	priceLong: ICountryPriceLocaleSettings;
	priceShort: ICountryPriceLocaleSettings;
	dateShort: string;
	dateLong: string;
}
export interface Country {
	continents: string[];
	countryCode: string;
	regionCodes: string[];
	currencyCode: string;
	currencySymbol: string;
	siteId: string;
	hreflangLanguageCodes?: string[];
	currencyConfig?: CountryCurrencyConfig;
	isDDPOptionEnabled: boolean;
	isDDPBadgeEnabledOnPDP: boolean;
	isVirtualTryOnDisabled: boolean;
	isVirtualMirrorDisabled: boolean;
	isBeautyVirtualTryOnDisabled: boolean;
	taxRate: number;
	localeSettings: ICountryLocaleSettings;
	socialLoginButtons?: string;
	priceBooksGroup?: string;
	availableLanguages?: string[];
	canonicalLinksMapping?: {[key: string]: string};
	externalUrl?: string;
	unitOfMeasure?: string;
	returnFee?: number | null;
	returnAuthCustomerGroupsToExclude?: string[];
	returnOrderAmountThreshold?: number | null;
}

export interface Language {
	id: string;
	default: boolean;
}

type AlgoliaSearchRefinement = {
	bucketValues: string;
	bucketDisplay: Record<string, string>;
	presentationId?: string | number;
	[key: string]: any;
};

export type AlgoliaSearchRefinements = Record<string, AlgoliaSearchRefinement[]>;

export type SitePreferences = {
	productSearchFilterGroups?: string;
	findInStoreTimeframeDays: number;
	loyaltyStandardConversionRate: number;
	loyaltySaleConversionRate: number;
	loyaltyCurrencyExchangeRates: object;
	storeLocatorGoogleMapsAPIKey: string;
	storeLocatorGoogleMapsStyle: object;
	MSDynamicsEnabled: string;
	mapStyle: string;
	Algolia_Translations: Record<string, Record<string, string>>;
	Algolia_CustomerGroups: string[];
	Algolia_Refinements: Array<{
		id: string;
		attribute: string;
		label: string;
		type: string;
		enableOnQuickSearch?: boolean;
		enableOnPlp?: boolean;
		whitelistPlp?: string[];
		blacklistPlp?: string[];
	}>;
	Algolia_SearchRefinements: AlgoliaSearchRefinements;
	disableExchangeForPreorder: boolean;
	enableExcludeFromSearch: boolean;
	enableExchange: boolean;
	StoreCreditEnable: boolean;
	enableNotAuthenticatedCustomerWishlist: boolean;
	myAccountFlyoutConfig: object;
	loginBeforeCheckoutEnabled: boolean;
	returnAuthorizationProvider: EReturnAuthorizationProvider;
	personalizationFlyoutTitle?: {
		[key: string]: string;
	};
	personalizationFlyoutDescription?: {
		[key: string]: string;
	};
	personalizationValidationConfig?: {
		maxNameLength?: number;
		maxNumberLength?: number;
	};
	personalizationTextConfig?: {
		fontFamilyName?: string;
		fontFamilyNumber?: string;
	};
	emarsysEnableSessionTracker: boolean;
	emarsysBrandPreference:string;
};

export enum EReturnAuthorizationProvider {
	SFCC = 'SFCC',
	RETURN_APP = 'ReturnApp',
}

type PasswordConfig = {
	forceLetters: boolean;
	forceMixedCase: boolean;
	forceNumbers: boolean;
	maxLength: number;
	minLength: number;
	minSpecialChars: number;
};

type CMS = {
	mode: ECMSMode;
	environment?: string;
};

export enum ECMSMode {
	LIVE = 'live',
	PREVIEW = 'preview',
}
